module.exports = __webpack_public_path__ + "img/nav-rule-act.8063061d.png";